import * as yup from "yup";
import { SCORING_TYPE } from "../models/scoringModel";
import { findOverlappingRangeIndices } from "../components/rules/RangeRulesEditor";
import errorMessages from "./errorMessages";

/**
 * Per-criterion Yup schema for the blocking validations in spec 2 section 7
 * that apply to a single criterion's own config (points > maxScore, RANGE
 * overlap, AI_MATCH completeness). Duplicate-criterionKey and locked-edit
 * checks need sibling/original context this schema doesn't have -- see
 * `validateNoDuplicateKeys`/`validateNoLockedEdits` in `hostValidation.js`,
 * which the host form (admin scenario creator / client recruitment form)
 * must run itself across the full criterion list.
 */
export const scoringConfigSchema = yup.object().when("scoringEnabled", {
    is: true,
    then: (schema) =>
        schema.shape({
            maxScore: yup.number().nullable().min(0).required(),
            valueRules: yup.array().when("scoringType", {
                is: SCORING_TYPE.VALUE,
                then: (s) =>
                    s.of(
                        yup.object({
                            points: yup.number().test(
                                "points-le-max",
                                errorMessages.pointsExceedMax,
                                function (value) {
                                    return value == null || value <= (this.options.context?.maxScore ?? Infinity);
                                }
                            ),
                        })
                    ),
            }),
            rangeRules: yup.array().when("scoringType", {
                is: SCORING_TYPE.RANGE,
                then: (s) =>
                    s
                        .of(
                            yup.object({
                                points: yup.number().test(
                                    "points-le-max",
                                    errorMessages.pointsExceedMax,
                                    function (value) {
                                        return value == null || value <= (this.options.context?.maxScore ?? Infinity);
                                    }
                                ),
                            })
                        )
                        .test("no-overlap", errorMessages.rangeOverlap, (rules) => findOverlappingRangeIndices(rules).size === 0),
            }),
            aiCriterion: yup.string().when("scoringType", {
                is: SCORING_TYPE.AI_MATCH,
                then: (s) => s.required(errorMessages.aiMatchMissingCriterion),
            }),
            aiLevels: yup.array().when("scoringType", {
                is: SCORING_TYPE.AI_MATCH,
                then: (s) => s.min(2, errorMessages.aiMatchMissingLevels),
            }),
        }),
});
